<ng-container *rxLet="collection.selectedItems$; let selectedItems">
  <ng-container *ngIf="selectedItems.size">
    <section cdkDrag cdkDragRootElement=".actions-tile" cdkDragHandle class="actions-tile" data-cy="actions-tile">
      <div class="actions-tile__main">
        <div class="count">
          {{ selectedAllEntries() ? collection.meta.totalCount : selectedItems.size }}
        </div>
        <div class="main-control">
          <div class="content">
            <ng-container *rxIf="showAllEntries">
              <div data-testid="select-all-entries" class="checkbox">
                <label class="checkbox__label" (click.zoneless)="selectAllEntries($event)">
                  <span class="checkbox__check" [class.checked]="selectedAllEntries()"></span>

                  <span class="checkbox__description">
                    {{ allEntriesSelectedInsteadText | translate: { total: collection?.meta?.totalCount } }}
                  </span>
                </label>
              </div>
            </ng-container>

            <div data-testid="select-all" class="checkbox">
              <label (click)="selectAll($event)" [class.disabled]="selectedAllEntries()" class="checkbox__label">
                <span class="checkbox__check" [class.checked]="collection.totalSelectedItems === selectedItems.size"></span>

                <span class="checkbox__description">{{ checkboxLabel | translate }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="actions-tile__actions-wrap">
        <div class="actions-tile__actions">
          <ng-container *rxFor="let action of actions; strategy: strategy$">
            <div
              *ngIf="action.show"
              class="action-item {{ action?.actionClass }}"
              data-cy="action-item"
              [class.mod-disabled]="action.disabled"
              (click)="action.click($event)">
              <div class="icon-wrap">
                <span class="icon {{ action.icon }}"></span>
              </div>

              <div class="name">
                <span>{{ action.name | translate }}</span>
              </div>
            </div>
          </ng-container>
        </div>

        <div (click)="cancel($event)" class="actions-tile__cancel">
          <i class="icon icon-Close_round_ico"></i>
        </div>
      </div>
    </section>
  </ng-container>
</ng-container>
